import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Ratesprocuredownload} from './ratesprocuredownload';


@Injectable()
export class FrtRateDownloadService {
  constructor(private http: HttpClient) {
  }

  private baseURI = '/tmssserver/api';

  /**
   *
   * @param: rateId
   * @param: pagenumber
   * @param: pageSize
   * @param: carrierId
   * @param: paramsObj
   */
  getRowDataWithPage(ratesPoc: Ratesprocuredownload, pagenumber: number, pageSize: number): any {
    return this.http.post(this.baseURI + '/ratesfrt/searchFRTRates' + '?page=' + pagenumber + '&size=' + pageSize , ratesPoc);
  }


  /**
   *
   * @param: sroMasterId
   * @param: pagenumber
   * @param: pageSize
   * @param: carrierId
   * @param: paramsObj
   */
  getRowDataForACCWithPage(sroMasterId, pagenumber: number, pageSize: number, carrierId: number, paramsObj: any, ratesBidCycleId: number): any {
    const orderByClause = paramsObj.find( x => x.name === 'orderByClause').value;
    return this.http.get(this.baseURI + '/ratesfrt/' + sroMasterId + '/sroMasterId/' + carrierId + '/' + ratesBidCycleId + '/' + orderByClause + '?page=' + pagenumber + '&size=' + pageSize);
  }

  /**
   *
   * @param: rateId
   * @param: carrierId
   * @param: paramsObj
   */
  exportDataFromServer(ratesPoc: Ratesprocuredownload): any {
    return this.http.post(this.baseURI + '/ratesfrt/searchFRTRates/csv/', ratesPoc);
  }

  /**
   *
   * @param: rateId
   * @param: carrierId
   * @param: paramsObj
   */
  exportDataForAccFromServer(sroMasterId , carrierId: number, paramsObj: any, ratesBidcyclesId): any {
    const orderByClause = paramsObj.find( x => x.name === 'orderByClause').value;
    return this.http.get(this.baseURI + '/ratesfrt/csv/' + sroMasterId + '/sroMasterId/' + carrierId + '/' + ratesBidcyclesId + '/' + orderByClause);
  }
}

